/* eslint-disable no-prototype-builtins */
/* eslint-disable no-async-promise-executor */
import Vue from "vue";
import ajax from "@/plugins/ajax";
import menuList from "../menuList";
import { Message } from "element-ui";

const state = {
  dldId: "", //店雷达id
  source: '', //入口来源 dld || admin
  buildType: '1688Web', //打包方式
  fullscreen: false, //全屏状态
  asideCollapse: false,
  showHeader: false,
  editAutoSave: false,
  packageTips: null, //增值包提示
  menuList,
  applyShopList: [], //当前用户的平台店铺数据
  applySelected: {
    //用户已选中的 平台 | 店铺 | 配置模板
    platform: "",
    shopId: {}, //多平台店铺 {平台A:''}
    commonTemplateId: "",
    publishTemplateId: {}, //多平台店铺模板 {店铺a:''}
  },
  applyShopTemplate: {}, //当前授权店铺模板
  statement: true, //免责声明勾选
  whitePathList: ["/collection/index", "/specialPage/crossStore", "/apply/crossStore", "/apply/collection/index"] //白名单路径
};

function getAccount(state) {
  if (!state.users || !state.users) {
    return "";
  }
  return state.users.userInfo.account;
}

const mutations = {
  setApplyShopList(state, data) {
    state.applyShopList = data;
    sessionStorage.setItem(
      `${getAccount(this.state)}-apply-shopList`,
      JSON.stringify(data)
    );
  },
  setEditAutoSave(state, data) {
    state.editAutoSave = data;
  },
  setFullscreen(state, data) {
    state.fullscreen = data;
  },
  setApplySelected(state, data) {
    for (let k in data) {
      if (Object.prototype.toString.call(data[k]) === '[object Object]') {
        for (let kk in data[k]) {
          if (!state.applySelected[k]) {
            state.applySelected[k] = {}
          }
          Vue.set(state.applySelected[k], kk, data[k][kk]);
        }
      } else {
        Vue.set(state.applySelected, k, data[k]);
      }
    }
    // 带上用户唯一标识
    localStorage.setItem(
      `${getAccount(this.state)}-apply-selected`,
      JSON.stringify(state.applySelected)
    );
  },
  setApplyShopTemplate(state, { shopId, key, value }) {
    if (!state.applyShopTemplate[shopId]) {
      Vue.set(state.applyShopTemplate, shopId, {});
    }
    Vue.set(state.applyShopTemplate[shopId], key, value);
    // 带上用户唯一标识
    localStorage.setItem(
      `temu-apply-template`,
      JSON.stringify(state.applyShopTemplate)
    );
  },
  setPackageTips(state, tipData) {
    state.packageTips = tipData;
  },
  setStatement(state, data) {
    state.statement = data;
  },
  setBuildType(state, data) {
    state.buildType = data;
  },
  setDldId(state, data) {
    state.dldId = data;
  },
  setSource(state, data) {
    state.source = data;
  },
};

const getters = {};

const actions = {
  getApplyShopList({ commit }, { reFetch = false, params = {} } = {}) {
    // 拉取应用店铺数据
    return new Promise(async (resolve) => {
      let applyShopList = sessionStorage.getItem(
        `${getAccount(this.state)}-apply-shopList`
      );
      if (applyShopList && !reFetch) {
        applyShopList = JSON.parse(applyShopList);
      } else {
        await ajax.post("/user/shop/shopListGet", params).then((data) => {
          applyShopList = data.result;
        });
      }
      commit("setApplyShopList", applyShopList);
      resolve(applyShopList);
    });
  },
  getTemuFreightTemplate({ commit }, { shopId, reFetch = false } = {}) {
    // 获取运费模板
    return new Promise(async (resolve) => {
      let applyTemplateData = localStorage.getItem(`temu-apply-template`);
      let freightTemplate = [];
      if (applyTemplateData) {
        applyTemplateData = JSON.parse(applyTemplateData);
      }

      if (
        !(
          applyTemplateData &&
          applyTemplateData[shopId] &&
          applyTemplateData[shopId].hasOwnProperty("freightTemplate")
        ) ||
        reFetch
      ) {
        await ajax
          .get(
            `/product/temu/getShopFreightTemplate?shopId=${shopId}&isSync=${reFetch}`
          )
          .then((res) => {
            if (res.code !== 200) {
              return Message.error(res.msg);
            }
            freightTemplate = res.result;
          });
      } else {
        freightTemplate = applyTemplateData[shopId]["freightTemplate"];
      }
      commit("setApplyShopTemplate", {
        shopId,
        key: "freightTemplate",
        value: freightTemplate,
      });
      resolve(freightTemplate);
    });
  },
  getTemuWarehouseTemplate({ commit }, { shopId, reFetch = false } = {}) {
    // 获取站点仓库模板
    return new Promise(async (resolve) => {
      let applyTemplateData = localStorage.getItem(`temu-apply-template`);
      let warehouseTemplate = [];
      if (applyTemplateData) {
        applyTemplateData = JSON.parse(applyTemplateData);
      }

      if (
        !(
          applyTemplateData &&
          applyTemplateData[shopId] &&
          applyTemplateData[shopId].hasOwnProperty("warehouseTemplate")
        ) ||
        reFetch
      ) {
        await ajax
          .get(
            `/product/temu/getShopWarehouse?shopId=${shopId}&isSync=${reFetch}`
          )
          .then((res) => {
            if (res.code !== 200) {
              return Message.error(res.msg);
            }
            warehouseTemplate = res.result;
          });
      } else {
        warehouseTemplate = applyTemplateData[shopId]["warehouseTemplate"];
      }
      commit("setApplyShopTemplate", {
        shopId,
        key: "warehouseTemplate",
        value: warehouseTemplate,
      });
      resolve(warehouseTemplate);
    });
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};
